"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = void 0;
var actions_1 = require("../../utils/actions");
var actions_2 = require("./actions");
exports.initialState = {
    paymentMethod: null,
    paypalResponse: {
        orderID: '',
    },
    stripeResponse: {
        id: '',
        created: '',
        livemode: '',
        type: '',
        card: {
            last4: '',
            exp_month: '',
            exp_year: '',
        },
    },
};
var setPaymentMethod = function (state, action) {
    var method = action.payload.method;
    return __assign(__assign({}, state), { paymentMethod: method || null });
};
var setPaymentField = function (state, action) {
    var _a;
    var _b = action.payload, fieldName = _b.fieldName, value = _b.value;
    return __assign(__assign({}, state), (_a = {}, _a[fieldName] = value, _a));
};
var clearPaymentFields = function () {
    return exports.initialState;
};
var paymentReducer = function (stateFromStore, action) {
    if (stateFromStore === void 0) { stateFromStore = exports.initialState; }
    var state = stateFromStore || exports.initialState;
    if ((0, actions_1.isType)(action, actions_2.setPaymentMethodAction)) {
        return setPaymentMethod(state, action);
    }
    else if ((0, actions_1.isType)(action, actions_2.setPaymentFieldAction)) {
        return setPaymentField(state, action);
    }
    else if ((0, actions_1.isType)(action, actions_2.clearPaymentFieldsAction)) {
        return clearPaymentFields();
    }
    else {
        return state;
    }
};
exports.default = paymentReducer;
